<template>
  <div class="form-group">
    <label v-bind:class="{ 'text-danger': current.errors && current.errors[object] }">{{
      titulo
    }}</label>
    <v-select
      label="nombre"
      v-model="current[object]"
      :filterable="false"
      :options="pilotos"
      @search="onSearch"
      :disabled="disabled"
      @input="onChange($event)"
    >
      <template slot="no-options">pilotos...</template>
      <template slot="option" slot-scope="option">
        <div class="selected d-center">
          {{ option.id }} - {{ option.usuario.name }} - {{ option.licencia_no }}
        </div>
      </template>
      <template slot="selected-option" slot-scope="option">
        <div class="selected d-center">
          {{ option.id }} - {{ option.usuario.name }} - {{ option.licencia_no }}
        </div>
      </template>
    </v-select>
    <small v-if="current.errors && current.errors[object]" class="form-text text-danger">{{
      current.errors[object]
    }}</small>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";

export default {
  props: {
    current: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
    },
    titulo: {
      type: String,
      default: "Piloto",
    },
    object: {
        type: String,
        required: true,
        default: 'piloto'  
    },
  },
  data() {
    return {
      pilotos: [],
    };
  },
  mounted() {
    this.refreshData();   
    },
  methods: {
    refreshData() {
      let self = this;
      DynamicService.fetch("transporte", "piloto", {
        page: 1,   
      }).then((res) => {
        self.pilotos = res.data.results;
      });
    },
    onChange(event) {
      this.$emit("onChange", event);     
    },
    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      DynamicService.fetch("transporte", "piloto", {
        quitar_paginacion: true,
        "filter[search]": search,
      }).then((res) => {
        vm.pilotos = res.data;
        loading(false);
      });
    }, 350),
  },
};
</script>
